import styled from "styled-components";
import { SLForm } from "~/pages/Sistema/componentes/SistemaList";

export const Container = styled(SLForm)`
  width: calc(100% - 0.8em);
  max-width: 100%;
`;
